<template>
  <div class="print-box tem p-1">
    <table class="prtable prtable-center prtable-bordered">
      <tr>
        <td class="more" colspan="4" style="text-align:center;">
          <span style="margin-bottom: 0; font-size: 15px;">CÔNG TY TNHH ĐAI MI VN</span>
        </td>
      </tr>
      <tr>
        <td colspan="4" class="more" style="line-height: 14px;font-size: 11px;">
          66/2 LK 2-5, BÌNH TRỊ ĐÔNG, TP. HCM <span style="margin-left: 10px;">ĐT:02866828806</span>
        </td>
      </tr>
      <tr>
        <td style="min-width: 60px;">Tên hàng</td>
        <td colspan="3" style="font-size: 14px;">
          <b v-if="manufacture.product">{{ manufacture.product.name }}</b>
          <!-- <span v-if="manufacture.productCustom != ''"><br>{{ manufacture.productCustom }}</span> -->
          <b v-if="manufacture.reason"><br />{{ manufacture.reason.name }}</b>
        </td>
      </tr>
      <tr>
        <td>Mã SP</td>
        <td colspan="3" style="font-size: 15px;">
          <b v-if="manufacture.product">{{ manufacture.product.code }}</b>
        </td>
      </tr>
      <tr>
        <td>Quy cách</td>
        <td colspan="2" style="font-size: 15px;">
          <b v-if="manufacture.productSpecify">{{ manufacture.productSpecify.name }}</b>
        </td>
        <td style="font-size: 15px;">mm</td>
      </tr>
      <tr>
        <td>Chiều dài</td>
        <td colspan="2" style="font-size: 15px;">
          {{ manufacture.length }}
        </td>
        <td style="font-size: 15px;">cm</td>
      </tr>
      <tr>
        <td>Màu sắc</td>
        <td style="font-size: 15px;" colspan="2">
          <b>{{ manufacture.colorText }}</b>
        </td>
        <td style="font-size: 17px;">{{ manufacture.colorCode1 }}</td>
      </tr>
      <tr>
        <td>Số lượng</td>
        <td style="font-size: 15px;">
          <b>{{ Tem.slbao }}</b>
        </td>
        <td style="font-size: 15px;">{{ manufacture.unit }}</td>
        <td style="font-size: 15px;">
          <span style="display: flex;align-items:center">
            <span style="width:100%" title="18: Số cuộn hoặc số bịt cho một tem">{{ Tem.slcbao }}</span>
            <div style="width:100%">
              <span style="display:block; border-bottom:1px solid #000">C</span>
              <span>B</span>
            </div>
          </span>
        </td>
      </tr>
      <tr>
        <td>Số Lot</td>
        <td style="font-size: 15px;" colspan="2">
          <b>{{ manufacture.code }}</b>
        </td>
        <td style="font-size: 15px;">
          <span title="19: trọng lượng gộp cho một tem">
            {{ $formatNumberFixed(Number(this.Tem.hesobao) * Number(this.Tem.slcbao) + Number(this.Tem.tlbao)) }}
          </span>
        </td>
      </tr>
      <tr>
        <td>QC</td>
        <td colspan="2" style="width:100px; font-size: 15px;">
          <base-input
            title="21: trọng lượng ống lõi hoặc bịt đựng hàng cho một tem"
            v-model="Tem.hesobao"
            placeholder="21: trọng lượng ống lõi hoặc bịt đựng hàng cho một tem"
            :mask="'number'"
          ></base-input>
        </td>
        <td style="font-size: 15px;">
          <span title="20: trọng lượng tịnh cho một tem">
            {{ $formatNumberFixed(Tem.tlbao) }}
          </span>
        </td>
      </tr>
      <tr>
        <td>Note</td>
        <td colspan="3" style="width:100px; font-size: 15px;">
          <textarea v-model="Tem.notebao" placeholder="Ghi chú" class="form-control"></textarea>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
import VueBarcode from 'vue-barcode';
export default {
  name: 'tem-bao',
  components: {
    barcode: VueBarcode
  },
  props: {
    manufacture: {},
    Tem: {},
    code: {},
    quantityOdd: {},
    temDetail: {},
    edit: {
      type: Boolean,
      default: false
    },
    isOdd: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    isEditNote: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      temInfo: {
        productName: '',
        productCode: '',
        manufacture_id: '',
        spec: ''
      }
    };
  },
  methods: {
    temHesoChange() {
      this.Tem.tlbaogop = Number(this.Tem.slcbao) * Number(this.Tem.hesobao) + Number(this.Tem.tlbao);
    }
  }
};
</script>
